
import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useBaseMutation } from './baseMutation';

export const useToggleMutation = () => {
  const { invalidateUpdates, showSuccessToast, showErrorToast } = useBaseMutation();

  const toggleActiveMutation = useMutation({
    mutationFn: async ({ id, is_active }: { id: number; is_active: boolean }) => {
      const { error } = await supabase
        .from('automated_updates')
        .update({ is_active })
        .eq('id', id);

      if (error) throw error;
    },
    onSuccess: () => {
      invalidateUpdates();
      showSuccessToast("Success", "Update status changed successfully");
    },
    onError: (error) => {
      console.error('Error toggling active status:', error);
      showErrorToast("Error", "Failed to update status");
    }
  });

  return { toggleActiveMutation };
};
